/**
 * 🟣 SINGLE SOURCE OF TRUTH for core-plan display pricing.
 *
 * Used by:
 *   - LandingPage.js  (homepage pricing section)
 *   - PlanSelection.js (in-dashboard "Choose a plan" / Change Plan flow)
 *
 * Stripe Payment Links + price IDs live in `backend/stripe_integration.py`.
 * The values below are PURELY for display - they must match the configured
 * Stripe products. If you change a price here, change it in Stripe too.
 */

export const PRICING_CONFIG = {
  taster: {
    monthly: { gbp: 299,  eur: 349,   usd: 379 },
    yearly:  { gbp: 2690, eur: 3149,  usd: 3410 },
  },
  growth: {
    monthly: { gbp: 599,  eur: 699,   usd: 749 },
    yearly:  { gbp: 5390, eur: 6290,  usd: 6740 },
  },
  authority: {
    monthly: { gbp: 1099, eur: 1289,  usd: 1349 },
    yearly:  { gbp: 9890, eur: 11599, usd: 12140 },
  },
};

export const CURRENCY_SYMBOL = { gbp: '£', eur: '€', usd: '$' };

/** Format a numeric amount (e.g. 11599 → "11,599"). */
export function formatAmount(amount) {
  return Number(amount).toLocaleString('en-US');
}

/**
 * Display string for a plan, e.g. priceLabel('taster','monthly','gbp') → "£299/month".
 * billingMode: 'monthly' | 'yearly'
 * currency:    'gbp' | 'eur' | 'usd'
 */
export function priceLabel(planId, billingMode, currency) {
  const cur = (currency || 'gbp').toLowerCase();
  const sym = CURRENCY_SYMBOL[cur] || '';
  const amt = PRICING_CONFIG[planId]?.[billingMode]?.[cur];
  if (amt == null) return '-';
  return `${sym}${formatAmount(amt)}${billingMode === 'yearly' ? '/year' : '/month'}`;
}

/** Yearly savings vs paying monthly × 12, rounded to nearest %. */
export function yearlySavingsPercent(planId, currency) {
  const cur = (currency || 'gbp').toLowerCase();
  const m = PRICING_CONFIG[planId]?.monthly?.[cur];
  const y = PRICING_CONFIG[planId]?.yearly?.[cur];
  if (!m || !y) return 0;
  const fullYear = m * 12;
  return Math.round(((fullYear - y) / fullYear) * 100);
}
